import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { TradeInstrumentPositionPrice } from '@/modules/trade/types/instrument';
import { Row, SkeletonLoader } from '@warrenbrasil/nebraska-web';

interface Props {
  position: TradeInstrumentPositionPrice;
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TodayPosition',
  props: {
    position: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  position: TradeInstrumentPositionPrice;
  isLoading: boolean;
}



const priceFormatted = computed(() => props.position.price?.formatted || '-');

return { __sfc: true,props, priceFormatted, Row, SkeletonLoader }
}

})